// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";
import { getFunctions, httpsCallable } from "firebase/functions";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";

const firebaseConfig = {
  apiKey: "AIzaSyCP3l6525PG9jz0TwfXoa9xsyljNStiwyc",
  authDomain: "unified-weather.firebaseapp.com",
  projectId: "unified-weather",
  storageBucket: "unified-weather.firebasestorage.app",
  messagingSenderId: "294352993666",
  appId: "1:294352993666:web:3689a3979aa24a97bba39b",
  measurementId: "G-KLRQB95X75"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
logEvent(analytics, 'landing_page_view');

// Enable AppCheck debug in development
if (process.env.NODE_ENV !== 'production') {
  window.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
}

// Initialize AppCheck using ReCaptcha v3
const appCheck = initializeAppCheck(app, {
  provider: new ReCaptchaV3Provider('6LdU3tUqAAAAAI85JjxZAYPt4NVBTabyCTIUHmSS'),
  // Set to true to allow automatic token refresh.
  isTokenAutoRefreshEnabled: true,
});

// Initialize Cloud Functions
const functions = getFunctions(app);

// Create a callable function (ensure this name matches your deployed function)
const getWeatherData = httpsCallable(functions, "api");

// Call the cloud function (you can pass any parameters needed by your function)
function callWeatherFunction(latitude, longitude) {
  // Set loading state in the UI:
  // Set a loading state in the UI:
  document.querySelector('.temperature').textContent = "Loading forecast...";
  var weatherDetails = document.querySelector('.weather-details');

  weatherDetails.style.display = 'none';

  // Call the cloud function with latitude and longitude
  getWeatherData({ lat: latitude, lon: longitude })
    .then((result) => {
      console.log("Cloud function result:", result.data);

      // Get today's date (format: YYYY-MM-DD)
      const today = new Date().toISOString().split("T")[0];
      let todaysWeather = result.data.aggregated.daily.find(
        (entry) => entry.date === today
      );

      // Fallback if today's weather is not available:
      if (!todaysWeather && result.data.aggregated.daily.length > 0) {
        todaysWeather = result.data.aggregated.daily[0];
      }

      // Count the number of providers:
      const providerCount = Object.keys(result.data.providers).length;

      if (todaysWeather) {
        const condition = getFeatherIcon(todaysWeather.condition);
        weatherDetails.style.display = 'block';
        // Update the main weather info
        document.querySelector('.temperature').textContent = todaysWeather.temperature + " °C";
        document.getElementById('weather-icon').setAttribute('data-feather', condition);
        feather.replace();

        // Update additional weather details
        document.querySelector('.humidity').textContent = todaysWeather.humidity + "%";
        document.querySelector('.wind-speed').textContent = todaysWeather.wind.speed + " m/s";
        document.querySelector('.precipitation-amount').textContent = todaysWeather.precipitation.amount + " mm";
        // document.querySelector('.cloud-coverage').textContent = "Clouds: " + todaysWeather.cloudCoverage + "%";
        document.querySelector('.provider-count').textContent = "Data aggregated from " + providerCount + " forecast providers";
      }
    })
    .catch((error) => {
      console.error("Error calling cloud function:", error);
      document.querySelector('.temperature').textContent = "Error loading forecast";
    });
}

function getFeatherIcon(condition) {
  const iconMap = {
    clear: 'sun',
    partlyCloudy: 'cloud',
    cloudy: 'cloud',
    fog: 'cloud',
    drizzle: 'cloud-drizzle',
    rain: 'cloud-rain',
    storm: 'cloud-lightning',
    sleet: 'cloud-rain', // Feathericons does not have a sleet icon, using cloud-rain
    snow: 'cloud-snow',
    unknown: 'cloud', // Default icon for unknown conditions
  };

  return iconMap[condition] || 'cloud'; // Default to 'cloud' if condition is not found
}


// Check if geolocation is available and then request the user's current position
if ("geolocation" in navigator) {
  navigator.geolocation.getCurrentPosition(
    (position) => {
      const { latitude, longitude } = position.coords;
      console.log(`User location: ${latitude}, ${longitude}`);
      callWeatherFunction(latitude, longitude);
      // Fetch the city name using reverse geocoding
      getCityName(latitude, longitude)
        .then((cityName) => {
          console.log("City:", cityName);
          document.querySelector('.city').innerHTML = cityName
          // Optionally pass the city name to your weather function or update the UI
          
        })
        .catch((error) => {
          console.error("Error retrieving city name:", error);
          // Even if the city name isn't available, still call the weather function
        });
    },
    (error) => {
      console.error("Error retrieving geolocation:", error);
      // Optionally, call your function with a default location here.
    }
  );
} else {
  console.error("Geolocation is not supported by this browser.");
  // Optionally, call your function with a default location.
}

// Reverse geocoding function using Nominatim API
function getCityName(lat, lon) {
  const url = `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lon}&format=json`;
  return fetch(url, {
    method: "GET",
    headers: {
      "Accept": "application/json",
    },
  })
    .then((response) => response.json())
    .then((data) => {
      console.log("Reverse geocoding data:", data);
      // Extract the city name (it could be under "city", "town", "village", or "hamlet")
      const address = data.address || {};
      const city = address.city || address.town || address.village || address.hamlet || address.municipality || "Unknown";
      return city;
    });
}
